'use client';
import { useCallback } from 'react';
import { useAppDependencyGraphProvider } from '../../../../../context/DependencyGraphProvider';
import { ComputeContextKeys } from '../../../../../hooks/computeContext/const';
import {
  type DeviceContextInStore,
  useGlobalAppStateStore,
} from '../../../../../stores/app/GlobalAppStateStore';

/**
 * The single write+notify funnel for the runtime-env slice. Notifies USER_CONTEXT
 * alongside DEVICE because the legacy `userContext.context` view is derived from this
 * slice — pre-existing `userContext.context.*` bindings must re-evaluate on every
 * device write.
 */
export function useSetDeviceContext() {
  const { setDeviceContext: setDeviceContextInStore } = useGlobalAppStateStore().hooks.useActions();

  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();

  const setDeviceContext = useCallback(
    (deviceContext: Partial<DeviceContextInStore>) => {
      setDeviceContextInStore(deviceContext);
      notifyDependencyChange({ id: ComputeContextKeys.DEVICE });
      notifyDependencyChange({ id: ComputeContextKeys.USER_CONTEXT });
    },
    [setDeviceContextInStore, notifyDependencyChange],
  );

  return { setDeviceContext };
}
